// extracted by mini-css-extract-plugin
export default {"preview":"PollPreview_preview__ypsgt"};